module.exports = __webpack_public_path__ + "static/img/ewm.6bf5275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ewm.png
// module id = 264
// module chunks = 1